import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * No Refill constent
   */
  {

    field: 'noRefillConsent',
    label:
      'I do not consent to an automatic refill, and I want someone to contact me to discuss.',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [{ key: 'moRefillConsent', value: 'Agree' }]
    }
  }
];

export default questionsModels;